import React from 'react';
import './BuildRealThings.css';

const BuildRealThings = () => {
  return (
    <section className="mc-section mc-build-things">
      <div style={{ textAlign: 'center' }}>
        <h2 className="mc-section-title mc-gradient-accent">Build Real Things</h2>
        <p className="mc-lsubtitle">Hands-On Experience</p>
      </div>
      
      <div className="mc-build-grid">
        <div className="mc-project-card">
          <div className="mc-project-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2L2 7l10 5 10-5-10-5z"></path><path d="M2 17l10 5 10-5"></path><path d="M2 12l10 5 10-5"></path></svg>
          </div>
          <h3 className="mc-project-title">Full Stack Project</h3>
          <p className="mc-project-desc">Deploy a real-world full-stack AI application from scratch to production.</p>
        </div>
        <div className="mc-project-card">
          <div className="mc-project-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon></svg>
          </div>
          <h3 className="mc-project-title">Hackathon</h3>
          <p className="mc-project-desc">Compete in our exclusive 6-hour hackathon to test your newly acquired skills under pressure.</p>
        </div>
        <div className="mc-project-card">
          <div className="mc-project-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="8" r="7"></circle><polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88"></polyline></svg>
          </div>
          <h3 className="mc-project-title">Exclusive Prizes</h3>
          <p className="mc-project-desc">Top performers get exciting rewards, a cash prize.</p>
        </div>
      </div>
    </section>
  );
};

export default BuildRealThings;
